/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/DesktopMac';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const DesktopMacIcon = withMuiAdapter(Base, 'DesktopMac');
